import { useCallback } from 'react';

import IconButton from 'src/components/UI/IconButton/IconButton';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
import { useFrillWidget } from './useFrillWidget';

export type FrillButtonProps = {
	disabled?: boolean;
};

const FrillButton = ( { disabled = false } : FrillButtonProps ) => {
	const widgetRef = useFrillWidget();

	const handleClick = useCallback( () => {
		widgetRef.current?.open();
	}, [ widgetRef ] );

	return (
		<Tooltip title="Feedback & Ideas" disabled={disabled}>
			<IconButton
				buttonClassName="frill-button"
				onClick={handleClick}
				size={18}
				icon="lightbulb"
				color="white"
				ariaLabel="Open feedback and ideas"
				disabled={disabled}
			/>
		</Tooltip>
	);
};

export default FrillButton;
